import { render, staticRenderFns } from "./TransactionsTable.vue?vue&type=template&id=63e28ec0&scoped=true&"
import script from "./TransactionsTable.vue?vue&type=script&lang=js&"
export * from "./TransactionsTable.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsTable.vue?vue&type=style&index=0&id=63e28ec0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e28ec0",
  null
  
)

export default component.exports